module.exports = __webpack_public_path__ + "img/tag-bottom-1x.76fc669.png";